import { useEffect, type ReactNode } from "react";
import { Box, CircularProgress, Typography, Button, Alert } from "@mui/material";
import { settingsStore } from "../settings/store";
import { useSettingsStatus } from "../hooks/useSettings";

export function SettingsGate({ children }: { children: ReactNode }) {
  const status = useSettingsStatus();
  useEffect(() => {
    void settingsStore.init();
  }, []);

  if (status === "idle" || status === "loading") {
    return (
      <Box
        sx={{
          minHeight: 240,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 2,
        }}
      >
        <CircularProgress size={32} />
        <Typography variant="body2" color="text.secondary">
          설정을 불러오는 중입니다…
        </Typography>
      </Box>
    );
  }

  if (status === "error") {
    return (
      <Box
        sx={{
          minHeight: 240,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          p: 3,
        }}
      >
        <Alert
          severity="error"
          sx={{ maxWidth: 480 }}
          action={
            <Button color="inherit" size="small" onClick={() => settingsStore.init()}>
              다시 시도
            </Button>
          }
        >
          <Typography variant="subtitle2" gutterBottom>
            설정을 불러오지 못했습니다
          </Typography>
          <Typography variant="body2">서버 연결 상태와 config.json 파일을 확인해 주세요.</Typography>
        </Alert>
      </Box>
    );
  }

  return <>{children}</>;
}
